import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { FaCalculator, FaAtom, FaFlask, FaDna, FaMountain, FaChartLine, FaChartBar, FaBrain } from "react-icons/fa";
import { Link } from "react-router-dom";

export default function IITJAMPrograms() {
  const jamPrograms = [
    { 
      name: "Mathematics", 
      icon: <FaCalculator size={40} />, 
      description: "Advanced mathematical concepts, analysis, algebra and differential equations",
      color: "#2196F3",
      path: "/jam-mathematics"
    },
    { 
      name: "Physics", 
      icon: <FaAtom size={40} />, 
      description: "Classical mechanics, electromagnetism, quantum physics and thermodynamics",
      color: "#FF9800",
      path: "/jam-physics"
    },
    { 
      name: "Chemistry", 
      icon: <FaFlask size={40} />, 
      description: "Organic, inorganic, physical chemistry and analytical techniques",
      color: "#F44336",
      path: "/jam-chemistry"
    },
    { 
      name: "Biotechnology", 
      icon: <FaDna size={40} />, 
      description: "Molecular biology, biochemistry, genetics and bioprocess engineering",
      color: "#4CAF50",
      path: "/jam-biotechnology"
    },
    { 
      name: "Geology", 
      icon: <FaMountain size={40} />, 
      description: "Mineralogy, petrology, stratigraphy and structural geology",
      color: "#795548",
      path: "/jam-geology"
    },
    { 
      name: "Mathematical Statistics ", 
      icon: <FaChartLine size={40} />, 
      description: "Seismology, gravity, magnetic fields and earth's interior studies",
      color: "#673AB7",
      path: "/jam-maths_stats"
    },
    { 
      name: "Economics", 
      icon: <FaChartBar size={40} />, 
      description: "Microeconomics, macroeconomics, growth theory and econometrics",
      color: "#009688",
      path: "/jam-economics"
    },
    { 
      name: "Advanced Mathematics", 
      icon: <FaBrain size={40} />, 
      description: "Advanced level mathematics and quantitative aptitude training for numerical sections",
      color: "#3F51B5",
      path: "/jam-advanced-mathematics"
    },
  ];

  return (
    <Container fluid className="py-4 px-3 px-md-4">
      {/* Header Section */}
      <Row className="justify-content-center text-center mb-4">
        <Col lg={8}>
          <h1 className="fw-bold mb-2">IIT-JAM Coaching Programs</h1>
          <p className="lead mb-0">Science, Economics & Mathematical Sciences</p>
        </Col>
      </Row>

      {/* JAM Program Cards - First Row */}
      <Row className="g-3 justify-content-center mb-3">
        {jamPrograms.slice(0, 4).map((program, index) => (
          <Col key={index} xs={12} sm={6} md={6} lg={3} className="d-flex">
            <Card 
              as={Link}
              to={program.path}
              className="text-center h-100 w-100 border-0 text-decoration-none text-dark"
              style={{
                borderRadius: "12px",
                transition: "all 0.3s ease",
                cursor: "pointer",
                boxShadow: "0 4px 15px rgba(0,0,0,0.07)",
                overflow: "hidden",
                backgroundColor: "white"
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.transform = "translateY(-6px)";
                e.currentTarget.style.boxShadow = "0 12px 25px rgba(0,0,0,0.09)";
                e.currentTarget.style.backgroundColor = `${program.color}05`;
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 4px 15px rgba(0,0,0,0.07)";
                e.currentTarget.style.backgroundColor = "white";
              }}
            >
              <Card.Body className="d-flex flex-column align-items-center p-3">
                {/* Icon Section */}
                <div 
                  className="mb-3 d-flex align-items-center justify-content-center"
                  style={{
                    color: program.color,
                    marginTop: "5px"
                  }}
                >
                  {program.icon}
                </div>
                
                {/* Divider */}
                <div 
                  className="w-25 mb-2" 
                  style={{ 
                    height: "2px", 
                    backgroundColor: program.color,
                    borderRadius: "2px"
                  }}
                ></div>
                
                {/* Text Content */}
                <Card.Title 
                  className="fw-bold mb-2"
                  style={{ fontSize: "1.1rem" }}
                >
                  {program.name}
                </Card.Title>
                
                <Card.Text className="text-muted mb-3" style={{ fontSize: "0.85rem" }}>
                  {program.description}
                </Card.Text>
                
                <div className="mt-auto">
                  <span 
                    className="d-inline-block mt-2" 
                    style={{ 
                      color: program.color, 
                      fontWeight: "600",
                      borderBottom: `2px solid ${program.color}`,
                      paddingBottom: "2px",
                      fontSize: "0.9rem"
                    }}
                  >
                    Explore Course →
                  </span>
                </div>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      {/* JAM Program Cards - Second Row */}
      <Row className="g-3 justify-content-center">
        {jamPrograms.slice(4, 8).map((program, index) => (
          <Col key={index + 4} xs={12} sm={6} md={6} lg={3} className="d-flex">
            <Card 
              as={Link}
              to={program.path}
              className="text-center h-100 w-100 border-0 text-decoration-none text-dark"
              style={{
                borderRadius: "12px",
                transition: "all 0.3s ease",
                cursor: "pointer",
                boxShadow: "0 4px 15px rgba(0,0,0,0.07)",
                overflow: "hidden",
                backgroundColor: "white"
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.transform = "translateY(-6px)";
                e.currentTarget.style.boxShadow = "0 12px 25px rgba(0,0,0,0.09)";
                e.currentTarget.style.backgroundColor = `${program.color}05`;
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 4px 15px rgba(0,0,0,0.07)";
                e.currentTarget.style.backgroundColor = "white";
              }}
            >
              <Card.Body className="d-flex flex-column align-items-center p-3">
                {/* Icon Section */}
                <div 
                  className="mb-3 d-flex align-items-center justify-content-center"
                  style={{
                    color: program.color,
                    marginTop: "5px"
                  }}
                >
                  {program.icon}
                </div>
                
                {/* Divider */}
                <div 
                  className="w-25 mb-2" 
                  style={{ 
                    height: "2px", 
                    backgroundColor: program.color,
                    borderRadius: "2px"
                  }}
                ></div>
                
                {/* Text Content */}
                <Card.Title 
                  className="fw-bold mb-2"
                  style={{ fontSize: "1.1rem" }}
                >
                  {program.name}
                </Card.Title>
                
                <Card.Text className="text-muted mb-3" style={{ fontSize: "0.85rem" }}>
                  {program.description}
                </Card.Text>
                
                <div className="mt-auto">
                  <span 
                    className="d-inline-block mt-2" 
                    style={{ 
                      color: program.color, 
                      fontWeight: "600",
                      borderBottom: `2px solid ${program.color}`,
                      paddingBottom: "2px",
                      fontSize: "0.9rem"
                    }}
                  >
                    Explore Course →
                  </span>
                </div>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
}